import { Modal, Form, Input, Button, Select, Badge, ModalProps } from 'antd'
import { categoryColors } from '@/constants/category'

import { useEffect, useMemo, useState } from 'react'
import { PayloadCategory } from '@/types/category'
import { Category } from '@/types/category'
import { useAddCategory } from '@/hooks/category/useAddCategory'
import { useUpdateCategory } from '@/hooks/category/useUpdateCategory'
import { useTranslation } from 'react-i18next'
import { AppModal } from '@/components/commons/appModal/appDrawer'
const { Item } = Form
const { TextArea } = Input
const { Option } = Select

interface IModalCategory extends ModalProps {
  branch: string
  onSave: () => void
  isEdit?: boolean
  category?: Category
}

export const ModalCategory = ({
  onSave,
  isEdit,
  category,
  ...props
}: IModalCategory) => {
  const { t } = useTranslation('catalog')
  const defaultCopyText = useMemo(() => {
    return {
      title: t('catalog.new.category'),
      action: t('common.add.category'),
    }
  }, [t])
  const [copyText, setCopyText] = useState(defaultCopyText)
  const { isPending: isLoadingAdd, mutateAsync: addCategory } = useAddCategory()
  const { isPending: isLoadingUpdate, mutateAsync: updateCategory } =
    useUpdateCategory()
  const [form] = Form.useForm()
  useEffect(() => {
    if (props.open) {
      if (isEdit && category) {
        form.setFieldsValue({
          name: category.name,
          color: category.color,
          description: category.description,
        })
        setCopyText({
          title: t('catalog.service.edit.category', { name: category.name }),
          action: t('catalog.service.update.category'),
        })
      } else {
        setCopyText(defaultCopyText)
        form.resetFields()
      }
    }
  }, [props.open, form, isEdit, category, t])
  const onFinish = (payload: PayloadCategory) => {
    if (isEdit) {
      updateCategory({
        branch: props.branch,
        payload,
        id: category?.id || '',
      }).then(() => {
        onSave()
      })
    } else {
      addCategory({
        branch: props.branch,
        payload,
      }).then(() => {
        onSave()
      })
    }
  }
  return (
    <AppModal title={copyText.title} footer={null} {...props}>
      <Form
        onFinish={onFinish}
        name="category_form"
        className="mt-5"
        layout="vertical"
        form={form}
      >
        <Item
          label={t('catalog.service.category.name')}
          name="name"
          rules={[{ required: true }]}
        >
          <Input size="large" />
        </Item>
        <Item
          help={t('catalog.category.color.help')}
          label={t('catalog.category.color')}
          name="color"
          rules={[{ required: true }]}
        >
          <Select size="large" placeholder={t('catalog.category.select.color')}>
            {categoryColors.map((el) => (
              <Option key={el.value}>
                <Badge color={el.value} text={el.label} />
              </Option>
            ))}
          </Select>
        </Item>
        <Item
          className="mt-12"
          name="description"
          label={t('catalog.category.desc')}
        >
          <TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
        </Item>

        <Button
          loading={isLoadingAdd || isLoadingUpdate}
          htmlType="submit"
          type="primary"
          size="large"
          block
        >
          {copyText.action}
        </Button>
      </Form>
    </AppModal>
  )
}
